<template>
	<GxzzProductListContent v-if="isGxzz" :initial-company-id="effectiveCompanyId" :website-info="websiteInfo?.data || {}" />
	<ProductListContent v-else :initial-company-id="effectiveCompanyId" />
</template>

<script setup>
import { computed } from 'vue';
import ProductListContent from '@/pages/productList/ProductListContent.vue';
import { queryWebsiteByCompanyId } from '@/api/index.js';
import { isGxzzFromWebsiteData } from '@/utils/business/siteGxzz.js';
import GxzzProductListContent from '../gxzz/products/components/GxzzProductListContent.vue';

const route = useRoute();
const effectiveCompanyId = computed(() => route.params.companyId ?? route.query.companyId ?? '');

// 根据 companyId 获取站点信息用于 TDK 及国械智造判断（与 seo-main domainInfo.isGxzz 同源）
const { data: websiteInfo } = await useAsyncData(
	() => `website-goods-${effectiveCompanyId.value}`,
	() => queryWebsiteByCompanyId(effectiveCompanyId.value),
	{ watch: [effectiveCompanyId] }
);

const companyName = computed(() => websiteInfo.value?.data?.companyName ?? '');
const province = computed(() => websiteInfo.value?.data?.province ?? '');
const isGxzz = computed(() => isGxzzFromWebsiteData(websiteInfo.value?.data));
const config = useRuntimeConfig();
const pcBase = (config.public.publicPcUrl || '').replace(/\/$/, '');
const canonicalHref = computed(() => (pcBase && effectiveCompanyId.value ? `${pcBase}/${effectiveCompanyId.value}/c` : ''));

const title = computed(() => (companyName.value ? `全部商品 - ${companyName.value}` : '全部商品'));
const keywords = computed(() => (companyName.value ? `全部商品,${companyName.value}` : '全部商品'));
const description = computed(() =>
	companyName.value
		? `${
				companyName.value
			}官方商品库，涵盖医疗器械、医用耗材等商品。正品保障、资质齐，商品附注册证或备案凭证，支持医院、药店及企业批量采购，服务${
				province.value || '全国'
			}地区。`
		: '全部商品，正品保障、资质齐全。'
);

// 使用 useHead 并设置 tagPriority 高于全局（nuxt.config 里为 1），否则 SSR 会沿用全局的 description/keywords
useHead(() => ({
	title: title.value,
	meta: [
		{ name: 'description', content: description.value, tagPriority: 10 },
		{ name: 'keywords', content: keywords.value, tagPriority: 10 },
	],
	link: canonicalHref.value ? [{ rel: 'canonical', href: canonicalHref.value }] : [],
}));
</script>
